import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedSupportState } from "./shared";

export interface SupportState extends SharedSupportState {}

  const initialState: SupportState = {
    ...sharedInitialState,
  };

export const supportSlice = createSlice({
    name : 'support',
    initialState,
    reducers : {
      ...sharedReducers,
      // Web-only.
      updateSupportSlice: (state, action) => {
        return action.payload;
      }
    },
    // Both bodies are empty in the app source — the cases exist but reset nothing.
    extraReducers: (builder) => {
      builder
        .addCase(userLogout, (state) => {

        })
        .addCase(supportLogout, (state) => {

        });
    },
})

export const {
    getQueries,
    getQueriesSuccess,
    submitQuery,
    submitQuerySuccess,
    getQueriesByTicketId,
    getQueriesByTicketIdSuccess,
    getQueriesLimit,
    getQueriesLimitSuccess,
    getZohoUser,
    getZohoUserSuccess,
    updateSupportSlice
  } = supportSlice.actions;
  export default supportSlice.reducer;
